// Human-readable source-log values for the Sources page (item 26). The raw value stays available per row.

/** 14.290000000000001 → "14.29"; 0.0614 → "0.0614"; 5638.94 → "5,638.94". */
export function fmtNumber(v) {
  if (!Number.isFinite(v)) return String(v);
  const a = Math.abs(v);
  const digits = a >= 100 ? 2 : a >= 1 ? 2 : a === 0 ? 0 : 4;
  return v.toLocaleString("en-US", { maximumFractionDigits: digits, minimumFractionDigits: 0 });
}

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;
const lowerFirst = (s) => (s ? s.charAt(0).toLowerCase() + s.slice(1) : s);

/** quote_validation → "0 of 122 contracts valid · 122 rejected: missing real NBBO · max age 60s". */
export function fmtQuoteValidation(q) {
  const total = Number(q.contracts) || 0;
  const valid = Number(q.valid) || 0;
  const parts = [`${valid} of ${plural(total, "contract")} valid`];
  const rejected = Object.entries(q.rejected || {}).filter(([, n]) => n);
  if (rejected.length) {
    const n = rejected.reduce((s, [, k]) => s + Number(k || 0), 0);
    const reasons = rejected.map(([why, k]) => `${rejected.length > 1 ? `${k} ` : ""}${lowerFirst(String(why).split(";")[0].trim())}`).join(", ");
    parts.push(`${n} rejected: ${reasons}`);
  }
  if (q.max_age_seconds != null) parts.push(`max age ${q.max_age_seconds}s`);
  return parts.join(" · ");
}

const KEY_LABELS = { y2: "2y", y10: "10y", as_of: "as of", spot: "spot", value: "value" };

/** Any source-log value as one short line. */
export function formatSourceValue(input, v) {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "number") return fmtNumber(v);
  if (typeof v === "boolean") return v ? "Yes" : "No";
  if (typeof v === "string") return v;
  if (Array.isArray(v)) return v.length === 0 ? "none" : v.length <= 4 ? v.map((x) => formatSourceValue(input, x)).join(", ") : `${v.length} items`;
  if (typeof v === "object") {
    if (input === "quote_validation" || ("contracts" in v && "valid" in v)) return fmtQuoteValidation(v);
    const entries = Object.entries(v).filter(([k]) => k !== "checked_at");
    const asOf = entries.find(([k]) => k === "as_of");
    const rest = entries.filter(([k]) => k !== "as_of").slice(0, 6)
      .map(([k, x]) => `${KEY_LABELS[k] || k.replace(/_/g, " ")} ${typeof x === "object" && x !== null ? "…" : formatSourceValue(k, x)}`);
    return [...rest, asOf ? `as of ${asOf[1]}` : null].filter(Boolean).join(" · ") || "—";
  }
  return String(v);
}

/** Is the formatted line different enough from the raw value to offer "show raw"? */
export const hasRaw = (v) => v !== null && v !== undefined && (typeof v === "object" || (typeof v === "number" && String(v) !== fmtNumber(v).replace(/,/g, "")));
